module.exports = __webpack_public_path__ + "static/media/53.0bc72956.webp";